import styled from "styled-components/macro";

import type { ThemeProps } from "models/styles/theme";
import { CssFlex, CssGrid, CssInput } from "styles/helpers/layout";
import { calculateRem } from "styles/mixins/calculateRem";

import searchIcon from "assets/icons/search.svg";

export const StyledField = styled(CssFlex)<ThemeProps>`
  flex-direction: column;
  row-gap: 0.5rem;

  label {
    font-weight: ${({ theme }: ThemeProps) => theme.font.weight.bold};
  }
`;

export const StyledStatsBox = styled(CssFlex)<ThemeProps>`
  padding: 1rem 1.5rem;
  column-gap: 3rem;
  align-items: center;
  justify-content: space-evenly;
  border-radius: 1rem;
  background: ${(props: ThemeProps) => props.theme.palette.neutral._999};
`;

export const StyledStat = styled(CssFlex)<ThemeProps>`
  align-items: center;
  column-gap: 1rem;"
`;

export const StyledProgressBarContainer = styled(CssGrid)<ThemeProps>`
  flex-grow: 1;
  column-gap: 1rem;
  align-items: center;
  justify-content: flex-end;
  grid-template-columns: 15rem auto;
`;

export const StyledInput = styled(CssInput)<ThemeProps>`
  background-image: url(${searchIcon});
  background-position: left;
  background-position-x: ${calculateRem(15)};
  background-repeat: no-repeat;
  background-size: ${calculateRem(25)};
  padding-left: ${calculateRem(48)};
`;
